import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Event from './component/event/event';
import SuccessRegistration from './component/successRegistration/successRegistration';
import PendingRegistration from './component/pendingRegistration/pendingRegistration';
import DeclinedRegistration from './component/declinedRegistration/declinedRegistration';
import CancelRegistration from './component/cancelRegistration/cancelRegistration';
import PaymentInProcess from './component/paymentInProcess/paymentInProcess';
import PaymentFailed from './component/paymentFailed/paymentFailed';

export default function RouterApp() {
  return (
    <Router>
      <Switch>
        <Route path="/event/:eventId" exact>
          <Event />
        </Route>
        <Route path="/event/:eventId/:eventRegistrationId" exact>
          <Event />
        </Route>
        <Route path="/declinedregistration/:eventId">
          <DeclinedRegistration />
        </Route>
        <Route path="/pendingapproval/:eventId/:eventRegistrationId">
          <PendingRegistration />
        </Route>
        <Route path="/pendingapproval/:eventId">
          <PendingRegistration />
        </Route>
        <Route path="/successregistration/:eventId">
          <SuccessRegistration />
        </Route>
        <Route path="/cancelregistration/:eventId/:eventRegistrationId">
          <CancelRegistration />
        </Route>
        <Route path="/paymentinprocess/:eventId">
          <PaymentInProcess />
        </Route>
        <Route path="/paymentauthfailed/:eventId">
          <PaymentFailed />
        </Route>
      </Switch>
    </Router>
  );
}
